(function() {
  'use strict';

  // This directive is to fix the ng-enter issue on Safari
  angular.module('ringbaPortal').directive('forceNgAnimate', forceNgAnimate);

  function forceNgAnimate(
    $timeout
  ) {
    'ngInject';

    const directive = {
      link: link
    };
    return directive;

    function link(scope, element, attrs) {
      $timeout(function() {
        element.addClass('ng-enter-active');
      }, Number.parseInt(attrs.animateDelay));
    }
  }
})();
